<template>
    <div class="grid">
      <slot />
    </div>
  </template>
  
  <script>
  export default {
    name: 'Grid'
  }
  </script>
  
  <style scoped>
  .grid {
    display: grid;
    gap: 1rem;
  }
  </style>


// WEBPACK FOOTER //
// src/components/importables/Grid.vue